import { render, staticRenderFns } from "./ExerciseResultContent.vue?vue&type=template&id=508f97bd&scoped=true&"
import script from "./ExerciseResultContent.vue?vue&type=script&lang=js&"
export * from "./ExerciseResultContent.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseResultContent.vue?vue&type=style&index=0&id=508f97bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f97bd",
  null
  
)

export default component.exports